import clsx from "clsx";
import styles from "./styles.module.scss";

interface ChartHeaderProps {
  title: string;
  titleId?: string;
  description?: string;
  descriptionId?: string;
  multipleControls?: boolean;
}

export function ChartHeader({
  title,
  titleId,
  description,
  descriptionId,
  multipleControls,
  children,
}: React.PropsWithChildren<ChartHeaderProps>) {
  return (
    <div
      className={clsx(
        styles.container,
        multipleControls && styles.multiple,
        !multipleControls && styles.single
      )}
    >
      <div className={styles.text}>
        <h2 className={styles.title} id={titleId}>
          {title}
        </h2>
        {description && (
          <p className={styles.description} id={descriptionId}>
            {description}
          </p>
        )}
      </div>

      {children && <div className={styles.controls}>{children}</div>}
    </div>
  );
}
